/*
 * @Author: LQ
 * @Date: 2022-06-08 08:26:16
 * @LastEditors: LQ
 * @LastEditTime: 2026-04-13 17:12:41
 * @FilePath: \scm-pc\src\official\store\modules\app.js
 * @Description:
 *
 * Copyright (c) 2022 by LQ/量迅, All Rights Reserved.
 */
import { unref } from 'vue';
import { cache, clearCache } from '@/utils/cache';
import { useFullscreen } from '@vueuse/core';
import { getList, getRegionById } from '@/api/web-init';
import { OFFICIAL_INIT_DATA_KEY } from '@/official/config/cache';
import { cacheTypeEnum, GLOBAL_LAST_UPDATE_TIME_KEY } from '@/config/cache';
import { APP_PAGE, LOGIN_PAGE } from '@/config/page';
import { getPageLocation } from '@/utils';
const { toggle, isFullscreen } = useFullscreen();

import { get_base_font_size } from '@/utils/browser';
import { isMobileByBodyWidth, isPromise } from '@/utils/is';

const defaultData = {
  header: {
    height: 100,
  },
  footer: {
    height: 300,
  },
  swiper: {
    show: true,
    height: 300,
  },
  hover: {
    show: false,
  },
  contentWidth: 1280,
  navigationColor: '',
  navigationBgColor: '#FFFFFF',
};

const state = () => ({
  initData: null, //cache(OFFICIAL_INIT_DATA_KEY),
  header: {
    show: true,
  },
  /* screen: {
    height: window.innerHeight,
    width: window.innerWidth,
    radio: window.devicePixelRatio || 1.0,
    topHeight: 68,
    mobileTopHeight: 44,
    baseFontSize: get_base_font_size(),
    isMobile: isMobileByBodyWidth(),
  }, */
  lastUpdateTime: 0,
  fullScreenList: [],
  listNavigation: [],
});
const getters = {
  getIsFixed(state, getters, rootState, rootGetters) {
    return rootGetters['user/getDomainInfo'].isFixed;
  },
  getLoginType(state, getters, rootState, rootGetters) {
    return rootGetters['user/getDomainInfo']?.loginType || 0;
  },
  getHeaderIsShow: (state) => {
    return state.header.show;
  },
  /**
   * @description: 判断是否获取到初始化数据
   * @param {*} state
   * @return {*}
   */
  getInitDataIsGot(state, getters, rootState, rootGetters) {
    return rootGetters['user/getDomainInfo']?.id;
  },

  getInitData(state, getters, rootState, rootGetters) {
    return rootGetters['user/getDomainInfo'] || {};
  },
  /**
   * @description: 处理查询页面数据所需要的参数
   * @param {*} state
   * @return {*}
   */
  getConnectionParam(state, getters, rootState, rootGetters) {
    const parameter = {};
    (rootGetters['user/getDomainInfo']?.connectionDataList || [])?.forEach(
      (item) => {
        parameter[item?.outputDataId] = item?.staticValue;
      },
    );
    return parameter;
  },

  getPageTitle(_state, getters) {
    return getters.getInitData?.name || '';
  },
  // PC端不固定高度，仅仅在大屏PC端中定义高度
  getContainerHeight: (state, getters, rootState, rootGetters) => {
    return (
      rootState.screen.screen.height -
      (getters.getHeaderIsShow && rootGetters['screen/getIsMobile']
        ? rootState.screen.screen.mobileTopHeight
        : 0)
    );
  },
  getWindowHeight: (state, getters, rootState, rootGetters) => {
    return rootState.screen.screen.height;
  },
  getTopHeight(state, getters, rootState, rootGetters) {
    return getters.getIsMobile
      ? rootState.screen.screen.mobileTopHeight
      : rootState.screen.screen.topHeight;
  },
  getContainerWidth(state, getters, rootState, rootGetters) {
    return rootState.screen.screen.width;
  },

  /**
   * @description: 获取上传更新时间
   * @param {*} state
   * @return {Number}
   */
  getLastUpdateTime(state) {
    return state.lastUpdateTime || 0;
  },

  /**
   * @description: 是否需要更新
   * @return {Boolean}
   */
  getNeedRefreshNavigation: (_state, getters) => {
    return getters.getLastUpdateTime === 0;
  },

  getPageBackgroundColor: (state, getters, rootState, rootGetters) => {
    return rootGetters['user/getDomainInfo']?.backgroundColor || '#fff';
  },

  /**
   * @description: 页脚信息
   * @return {Object}
   */
  getFooter: (state, getters, rootState, rootGetters) => {
    return {
      ...(rootGetters['user/getDomainInfo']?.listFoot?.[0] || {}),
      height:
        rootGetters['user/getDomainInfo']?.bottomHeight ||
        defaultData.footer.height,
    };
  },
  /**
   * @description: 页头信息
   * @return {Object}
   */
  getHeader: (state, getters, rootState, rootGetters) => {
    return {
      height:
        rootGetters['user/getDomainInfo']?.headHeight ||
        defaultData.header.height,
    };
  },
  /**
   * @description: 悬浮窗信息
   * @return {Object}
   */
  getHover: (state, getters, rootState, rootGetters) => {
    return rootGetters['user/getDomainInfo']?.listHover || [];
  },
  /**
   * @description: 所有链接
   * @return {Array}
   */
  getLinks: (state, getters, rootState, rootGetters) => {
    return rootGetters['user/getDomainInfo']?.listLink || [];
  },
  /**
   * @description: 管理链接
   * @return {Array}
   */
  getManageLinks: (_state, getters) => {
    return getters.getLinks.filter((item) => item.type === 2);
  },
  /**
   * @description: 友情链接
   * @return {Array}
   */
  getFriendLinks: (_state, getters) => {
    return getters.getLinks.filter((item) => item.type === 1);
  },

  /**
   * @description: 轮播图链接
   * @return {*}
   */
  getSwiper: (state, getters, rootState, rootGetters) => {
    const swiperList = rootGetters['user/getDomainInfo']?.listSwiper || [];
    return {
      show:
        swiperList?.length &&
        (rootGetters['user/getDomainInfo']?.swiperIsShow ??
          defaultData.swiper.show),
      height:
        rootGetters['user/getDomainInfo']?.swiperHeight ||
        defaultData.swiper.height,
      list: swiperList,
    };
  },

  getSwiperHeight: (_state, getters) => {
    return getters.getSwiper.height;
  },
  getSwiperIsShow: (_state, getters, _rootState, rootGetters) => {
    return !!getters.getSwiper.show && rootGetters['navigation/getShowSwiper'];
  },
  getContentWidth: (state, getters, rootState, rootGetters) => {
    return (
      rootGetters['user/getDomainInfo']?.contentWidth ||
      defaultData.contentWidth
    );
  },
  getNavigationColor: (state, getters, rootState, rootGetters) => {
    return (
      rootGetters['user/getDomainInfo']?.navigationColor ||
      defaultData.navigationColor
    );
  },
  getNavigationBgColor: (state, getters, rootState, rootGetters) => {
    return (
      rootGetters['user/getDomainInfo']?.navigationBgColor ||
      defaultData.navigationBgColor
    );
  },
  getHeaderHeight: (_state, getters) => {
    return getters.getHeader.height;
  },

  getLogoUrl: (state, getters, rootState, rootGetters) => {
    return rootGetters['user/getDomainInfo']?.logoImage;
  },

  getLogoSvg: (state, getters, rootState, rootGetters) => {
    return rootGetters['user/getDomainInfo']?.logoSvg || '';
  },
  getLogoTitle: (state, getters, rootState, rootGetters) => {
    return rootGetters['user/getDomainInfo']?.logoTitle || '';
  },
  getLogoSubTitle: (state, getters, rootState, rootGetters) => {
    return rootGetters['user/getDomainInfo']?.logoSubTitle || '';
  },

  getIsFullscreen: (state, getters) => {
    return isFullscreen.value;
  },

  getIndexPageId: (state, getters, rootState, rootGetters) => {
    console.log(
      rootGetters,
      getters.getIsBigScreen,
      rootGetters['user/getDomainInfo']?.pageId,
    );
    return getters.getIsBigScreen
      ? rootGetters['user/getDomainInfo']?.outputPageId
      : rootGetters['user/getDomainInfo']?.pageId;
  },

  getRegionNameType: (state, getters, rootState, rootGetters) => {
    return (
      ~~rootGetters['user/getDomainInfo']?.regionName?.type ||
      rootGetters['user/getDomainInfo']?.type
    );
  },

  getIsBigScreen: (_state, getters) => {
    return getters.getRegionNameType === 2;
  },

  getIsRedirectToApp: (_state, getters) => {
    return getters.getRegionNameType === 3;
  },

  getRouterCompanySn: (state, getters, rootState, rootGetters) => {
    return (
      rootGetters['user/getDomainInfo']?.regionName?.appCompanySn ||
      rootGetters['user/getDomainInfo']?.regionName?.companySn ||
      rootGetters['user/getDomainInfo']?.companySn
    );
  },

  getCurrentRegionId: (state, getters, rootState, rootGetters) => {
    return rootGetters['user/getDomainInfo']?.id || 0;
  },
  getSearchId: (state, getters, rootState, rootGetters) => {
    return rootGetters['user/getDomainInfo']?.searchId;
  },
  getTitle: (state, getters, rootState, rootGetters) => {
    return rootGetters['user/getDomainInfo']?.title;
  },

  getVisitCount: (state, getters, rootState, rootGetters) => {
    return parseInt(rootGetters['user/getDomainInfo']?.visitorNum || 0);
  },
  getBaseFontSize: (state, getters, rootState, rootGetters) => {
    return rootState.screen.screen.baseFontSize || 10;
  },
  getIsMobile: (state, getters, rootState, rootGetters) => {
    return rootState.screen.screen.isMobile;
  },
  gitTitle: (state, getters, rootState, rootGetters) => {
    return rootGetters['user/getDomainInfo'].indexName || '首页';
  },
  getVersion: (state, getters, rootState, rootGetters) => {
    // 强制设置为新版本
    return rootGetters['user/getDomainInfo']?.type === 4 ? 2 : 1;
  },
  getFullScreenList: (state) => {
    return state.fullScreenList || [];
  },
};

const mutations = {
  /* WINDOW_SIZE_CHANGE: (state) => {
    state.screen.height = window.innerHeight;
    state.screen.width = window.innerWidth;
    state.screen.baseFontSize = get_base_font_size();
    state.screen.isMobile = isMobileByBodyWidth();
  }, */
  SET_FULLSCREEN: (state) => {
    toggle();
  },
  /**
   * @description: 缓存网站初始化数据
   * @return {*}
   */
  SET_INIT_DATA: (state, data) => {
    state.initData = data;
    if (data) {
      cache(OFFICIAL_INIT_DATA_KEY, data);
    }
    state.lastUpdateTime = Date.now();
  },
  SET_INIT_NAVIGATION: (state, data) => {
    state.listNavigation = data;
  },
  SET_FULL_SCREEN_LIST: (state, data) => {
    state.fullScreenList = data || [];
  },
};
const actions = {
  /* windowSizeChange({ commit }) {
    commit('WINDOW_SIZE_CHANGE');
  }, */
  toggleFullscreen({ commit }) {
    commit('SET_FULLSCREEN');
  },
  clearData({ commit }) {
    commit('SET_INIT_DATA', null);
  },
  init: async ({ commit, dispatch, getters, rootGetters }, id) => {
    try {
      dispatch('clearData');

      // 更新公司获取状态
      commit('user/SET_COMPANY_FETCH_STATUS', 'loading', { root: true });

      const fn = id ? getRegionById : getList;
      const result = (await fn(id)) || {};
      commit('SET_INIT_DATA', result?.data || {});
      const lastUpdateTime = parseInt(result?.lastUpdateTime || 0);
      if (lastUpdateTime > 0) {
        const lastUpdateTimeCache = parseInt(
          cache(GLOBAL_LAST_UPDATE_TIME_KEY),
        );

        const needReload =
          lastUpdateTimeCache > 0 && lastUpdateTime > lastUpdateTimeCache;
        if (needReload) {
          clearCache(cacheTypeEnum.SESSION, true);
          clearCache(cacheTypeEnum.LOCAL, true);
          clearCache(cacheTypeEnum.API, true);
        }
        cache(GLOBAL_LAST_UPDATE_TIME_KEY, lastUpdateTime, { immediate: true });
        if (needReload) {
          //清除IndexedDB
          const result = clearCache(cacheTypeEnum.API_STORAGE, true);

          if (isPromise(result)) {
            result
              .then(() => {
                window.location.reload();
              })
              .catch((error) => {
                console.error(error);
              });
          } else {
            window.location.reload();
          }

          //
        }
      }
      //设置登录公司信息
      commit(
        'user/SET_COMPANY_INFO',
        {
          appCompanySn: getters['getRouterCompanySn'],
          appType: getters['getRegionNameType'],
        },
        { root: true },
      );
      // 更新公司获取状态
      commit('user/SET_COMPANY_FETCH_STATUS', 'success', { root: true });
      if (getters['getIsRedirectToApp'] && getPageLocation() !== 'login') {
        window.location.href = APP_PAGE;
      }
    } catch (error) {
      console.error(error);

      // 更新公司获取状态
      commit('user/SET_COMPANY_FETCH_STATUS', 'failed', { root: true });
    }
  },
  initNavigation({ commit }, data) {
    commit('SET_INIT_NAVIGATION', data);
  },
  setFullScreenList({ commit }, data) {
    commit('SET_FULL_SCREEN_LIST', data);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
